module.exports = __webpack_public_path__ + "img/2.34eff56d.png";